import { render, staticRenderFns } from "./SubmitBar.vue?vue&type=template&id=59dea93f&"
import script from "./SubmitBar.vue?vue&type=script&lang=js&"
export * from "./SubmitBar.vue?vue&type=script&lang=js&"
import style0 from "./SubmitBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})
